// Module
var code = `<ex-mono-occurrence-ecran mono-occurrence-options="vm.monoOccurrenceOptions"> <ex-mono-occurrence-ecran-bas> <ex-card-multi-advanced ex-bloc="fce" lbl-titre="LBL_BLC_FCE" multi-occurrence-options="vm.fceMultiOccurrenceOptions"> </ex-card-multi-advanced> </ex-mono-occurrence-ecran-bas> </ex-mono-occurrence-ecran>`;
// Exports
module.exports = code;